import React from 'react'

//Social Icons
import { FaBehance, FaFacebook, FaLinkedin, FaTwitter } from 'react-icons/fa'

import techRec_serv_img from '../images/technical-recruitment-is.png'
// import techRec_serv_img from '../images/technical-recruitment-is.png'
// import techRec_serv_img from '../images/technical-recruitment-is.png'
// import techRec_serv_img from '../images/technical-recruitment-is.png'

export const servicesHomeData = [
  {
    //id: 1,
    infoHeadline: 'Technical Recruitment',
    infoDescription:
      'We are not headhunters, we are the matchmakers between Clients and candidates. We search for the best possible candidates across the globe for our valuable clients. We deliver the candidates in a shape that they can be productive for our clients. Full stack developers - Infrastructure/ Cloud Engineers - DevOps - Database Engineers - Network Engineers',
    imgStart: true,
    infoImgSrc: techRec_serv_img,
    infoImgAlt: 'technical recruitment',
    // url: '',
    // linkText: 'Technical recruitment',
  },
  {
    //id: 2,
    infoHeadline: 'Infrastructure/ Cloud automation and orchestration',
    infoDescription:
      'We provide Server, Network, Storage, Backup, Monitoring and desktop support management for our clients. Our expert certified professionals do all kinds of troubleshooting and configuration related with your IT infrastructure. VMware - AWS Cloud solutions - Automation - Monitoring - Backup - Docker - Kubernetes - Openshift',
    imgStart: false,
    infoImgSrc: techRec_serv_img,
    infoImgAlt: 'Infrastructure/ Cloud automation and orchestration',
  },
  {
    //id: 3,
    infoHeadline: 'Data Center Services',
    infoDescription:
      'Starting from Racking-stacking, cabling, operations of smart hands, Server and network provisioning and many more.',
    imgStart: true,
    infoImgSrc: techRec_serv_img,
    infoImgAlt: 'Data Center Services',
  },
  {
    //id: 4,
    infoHeadline: 'Software/ web solutions',
    infoDescription:
      'We transform your business process into an automated tool so that it can do continuous delivery according to our business needs. We have team experts with Java, .Net/C# and web technologies (frontend & backend). We provided hosted services for your software and we provide services/ bug-fixing/ customization/revision upgrading services for our software.',
    imgStart: false,
    infoImgSrc: techRec_serv_img,
    infoImgAlt: 'Software/ web solutions',
  },
]

export const socialLinkData = [
  {
    id: 1,
    url: 'https://www.facebook.com',
    icon: <FaFacebook />,
  },
  {
    id: 2,
    url: 'https://www.twitter.com',
    icon: <FaTwitter />,
  },
  {
    id: 3,
    url: 'https://www.linkedin.com',
    icon: <FaLinkedin />,
  },
  {
    id: 4,
    url: 'https://www.behance.com',
    icon: <FaBehance />,
  },
]
